import { Suspense } from 'react';

import { ChunkLoadErrorBoundary } from '@trello/error-boundaries';
import { useFeatureFlag } from '@trello/feature-flag-client';
import { useLazyComponent } from '@trello/use-lazy-component';

export const LazyBoardCanvasModernizationInternalOnboarding = () => {
  const isInAtlassianEnterprise = useFeatureFlag('atlassian-team', false);
  const BoardCanvasModernizationInternalOnboarding = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "board-canvas-modernization-internal-onboarding" */ './BoardCanvasModernizationInternalOnboarding'
      ),
    {
      namedImport: 'BoardCanvasModernizationInternalOnboarding',
      preload: isInAtlassianEnterprise,
    },
  );

  if (!isInAtlassianEnterprise) return null;

  return (
    <ChunkLoadErrorBoundary fallback={null}>
      <Suspense fallback={null}>
        <BoardCanvasModernizationInternalOnboarding />
      </Suspense>
    </ChunkLoadErrorBoundary>
  );
};
